const en = {
  loading: 'Loading news...',
  title: 'News',
  add: 'Add news',
  empty: 'No news yet',
  /** The title of a new news item, which has to be changed before saving */
  titlePlaceholder: '[Title]',
  saveFailed: 'Failed to save news item',
  deleteFailed: "Couldn't delete this news item. Reload the tab and try again.",
  newItem: 'New news item',
  editItem: 'Edit news item',
  titleLabel: 'Title',
  summary: 'Summary',
  summaryHint: 'Shown under the title in the app\'s news list',
  body: 'Body',
  bodyHint: 'HTML, shown when the news item is opened',
  image: 'Image',
  notifyUsers: 'Send a push notification to all users',
  saving: 'Saving...',
  /** Deletes the news item */
  remove: 'Remove',
  removing: 'Removing...',
};

const fr: typeof en = {
  loading: 'Chargement des actus...',
  title: 'Actus',
  add: 'Ajouter une actu',
  empty: 'Aucune actu pour l\'instant',
  titlePlaceholder: '[Titre]',
  saveFailed: 'Impossible d\'enregistrer l\'actu',
  deleteFailed: "Impossible de supprimer cette actu. Rechargez l'onglet et réessayez.",
  newItem: 'Nouvelle actu',
  editItem: 'Modifier l\'actu',
  titleLabel: 'Titre',
  summary: 'Résumé',
  summaryHint: 'Affiché sous le titre dans la liste des actus de l\'app',
  body: 'Contenu',
  bodyHint: 'HTML, affiché à l\'ouverture de l\'actu',
  image: 'Image',
  notifyUsers: 'Envoyer une notification push à tous les festivaliers',
  saving: 'Enregistrement...',
  remove: 'Supprimer',
  removing: 'Suppression...',
};

const messages = { en, fr };
export default messages;
